import { gql } from "@apollo/client";
import { PRODUCT_BASE_INFO_FRAGMENT } from "pages/products/v3/graphql";

export const FETCH_GTM_PROJECTS = gql`
  query FETCH_GTM_PROJECTS {
    gtmProjects {
      results {
        id
        startUpProject {
          id
          team
        }
        name
        state
        archivedAt
      }
    }
  }
`;

export const FETCH_GTM_PROJECT = gql`
  query FETCH_GTM_PROJECT($id: ID!) {
    gtmProject(id: $id) {
      id
      name
      state
      archivedAt
      projectNotes
      sourceProduct {
        id
        number
        name
        version
      }
      startUpProject {
        id
        team
        name
        owner {
          id
          firstName
        }
        data
        imageUrls {
          id
          url
          thumb: url(width: 300)
        }
      }
      products {
        id
        data
      }
      productNotes
      productInitialSampleSent
      productFinalSampleSent

      logisticsData
      complianceData
      trialOrderData

      packagings {
        id
        basic
        design
        marketing
        item
        bom
      }

      timelinePackagingReadyDate
      timelineSampleForSalesDate
      timelineTrialOrderDate
      timelineProductionStartDate
      timelineMarketLaunchDate

      startUpProject {
        id
        data
        owner {
          id
          firstName
        }
      }

      createdProducts {
        id
        name
        number
        isActive
        isSalable
        isPurchasable
        company
        odooId
        odooIdInc
        gtmProjectComponentId
        gtmProjectComponentName
      }
      productLines {
        id
        name
      }
      productManager {
        id
        firstName
        email
      }
      marketingManager {
        id
        firstName
        email
      }
      productConfirmedAt
      packagingConfirmedAt
      logisticsConfirmedAt
      complianceConfirmedAt
      trialOrderConfirmedAt
    }
    allMaterials {
      id
      name
    }
    suppliers: allFactories(isActive: true) {
      id
      name
    }
    allLabTestStandards {
      id
      name
    }
  }
`;

export const SAVE_GTM_PROJECT = gql`
  mutation SAVE_GTM_PROJECT(
    $id: ID!
    $name: String
    $state: String
    $productManagerId: ID
    $marketingManagerId: ID
    $productConfirmedAt: DateTime
    $packagingConfirmedAt: DateTime
    $logisticsConfirmedAt: DateTime
    $complianceConfirmedAt: DateTime
    $trialOrderConfirmedAt: DateTime
    $projectNotes: String
    $resetToState: String
    $input: GTMProjectInput
  ) {
    saveGtmProject(
      id: $id
      name: $name
      state: $state
      productManagerId: $productManagerId
      marketingManagerId: $marketingManagerId
      productConfirmedAt: $productConfirmedAt
      packagingConfirmedAt: $packagingConfirmedAt
      logisticsConfirmedAt: $logisticsConfirmedAt
      complianceConfirmedAt: $complianceConfirmedAt
      trialOrderConfirmedAt: $trialOrderConfirmedAt
      projectNotes: $projectNotes
      resetToState: $resetToState
      input: $input
    ) {
      gtmProject {
        id
        name
        state
        projectNotes
        productManager {
          id
          firstName
          email
        }
        marketingManager {
          id
          firstName
          email
        }
        productInitialSampleSent
        productFinalSampleSent
        productConfirmedAt
        packagingConfirmedAt
        logisticsConfirmedAt
        complianceConfirmedAt
        trialOrderConfirmedAt
        archivedAt
        sourceProduct {
          id
          number
          name
          version
        }
      }
    }
  }
`;

export const FETCH_GTM_SOURCE_PRODUCT_IMPORT_DATA = gql`
  query FETCH_GTM_SOURCE_PRODUCT_IMPORT_DATA($id: ID!) {
    product(id: $id) {
      ...productBaseInfo
      pantone: finalPantone
      productLine {
        id
        hsCode
        hsCodeForEu
        hsCodeForUs
        customsName
        customsBrand
        customsUsage
        customsValue
        customsSize
        customsMaterials
        materials {
          id
          material {
            id
            name
          }
        }
      }
      activePrices {
        id
        currency
        price
        minQty
        company
        supplier: factory {
          id
          name
        }
      }
      complianceCertificates {
        id
        certificateType
        certificateNumber
        title
        fileUrls
      }
      labTestReports {
        id
        title
        reportNumber
        fileUrls
        standards {
          id
          name
        }
      }
      defaultQty
      itemsPerSet
      children {
        id
        qty
        product {
          id
          name
          activePrices {
            id
            currency
            price
            minQty
            company
            supplier: factory {
              id
              name
            }
          }
        }
      }
    }
  }
  ${PRODUCT_BASE_INFO_FRAGMENT}
`;

export const GTM_PROJECT_SAVE_PRODUCT = gql`
  mutation GTM_PROJECT_SAVE_PRODUCT(
    $gtmProjectId: ID!
    $productLineVersionId: ID
    $data: String!
    $deleted: Boolean
  ) {
    gtmProjectSaveProduct(
      gtmProjectId: $gtmProjectId
      productLineVersionId: $productLineVersionId
      data: $data
      deleted: $deleted
    ) {
      gtmProject {
        id
        products {
          id
          data
        }
      }
    }
  }
`;

export const GTM_PROJECT_SAVE_PACKAGING = gql`
  mutation GTM_PROJECT_SAVE_PACKAGING(
    $gtmProjectId: ID
    $packagingId: ID
    $deleted: Boolean
    $basic: String
    $design: String
    $marketing: String
    $item: String
    $bom: String
  ) {
    gtmProjectSavePackaging(
      gtmProjectId: $gtmProjectId
      packagingId: $packagingId
      deleted: $deleted
      basic: $basic
      design: $design
      marketing: $marketing
      item: $item
      bom: $bom
    ) {
      gtmProject {
        id
        packagings {
          id
          basic
          design
          marketing
          item
          bom
        }
      }
    }
  }
`;

export const ARCHIVE_GTM_PROJECT = gql`
  mutation ARCHIVE_GTM_PROJECT($id: ID!) {
    archiveGtmProject(id: $id) {
      gtmProject {
        id
        archivedAt
      }
    }
  }
`;

export const FETCH_GTM_SOURCE_PRODUCTS = gql`
  query FETCH_GTM_SOURCE_PRODUCTS($ids: [ID]) {
    products(ids: $ids) {
      results {
        id
        name
        number
        isActive
        isSalable
        isPurchasable
        company
        odooId
        odooIdInc
      }
    }
  }
`;
